export function popupWindow(file, width, height)
{
  if (navigator.appName === "Microsoft Internet Explorer") { width=width+20; height=height+20; }
  if (parseInt(navigator.appVersion, 10) < 4) { width=width+20; height=height+20; }
  const newWindow = window.open(file,"PopupWindow","dependent=yes,toolbar=no,location=no,status=no,scrollbars=yes,resizable=no,width="+width+",height="+height);
  if (navigator.appName === "Netscape" && parseInt(navigator.appVersion, 10) < 3)
    window.open(file,"PopupWindow","status=no,scrollbars=yes,resizable=no,width="+width+",height="+height);
  if (parseInt(navigator.appVersion, 10) >= 3 && navigator.appName === "Netscape")
    newWindow.focus();
}
